import React, { Component } from 'react';
import { Modal, Button, Tabs } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import FloorPriceDetail from './FloorPriceDetail';
import GPCalculateLogModal from './GPCalculateLogModal';

const TabPane = Tabs.TabPane;

class OperationLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        isQuotation: '',
        tabs: [{tab: '临床评估', key: '0'}],
        talAuth: false, // 领域leader
        isSeniorUserBo: false,
        isLineDeptBO: false,
        isGpFinSet: false,
        isLineCharge: false,
    }

    show = (record = {}, isQuotation, haveTotalPriceRequest = false, talAuth = false, isSeniorUserBo = false, isLineDeptBO = false, isGpFinSet = false, isLineCharge = false) => {
        const { tabs } = this.state;
        if (haveTotalPriceRequest) {
            tabs.push({tab: '总价申请', key: '1'})
        }
        this.setState({
            record,
            visible: true,
            isQuotation,
            tabs,
            talAuth,
            isSeniorUserBo,
            isLineDeptBO,
            isGpFinSet,
            isLineCharge,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record, isQuotation } = this.state;
        const { evaluateCode } = record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryOperateLogList,
            data: { 
                isQuotation,
                evaluateCode, 
                limit: 9999, 
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.datas,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { isQuotation, talAuth, isSeniorUserBo, isLineDeptBO, isGpFinSet, isLineCharge } = this.state;
        const { curRole } = sessionStorage;
        const isFIN = curRole == 'FIN';
        const columns = isQuotation == '0' ? [{
            title: '操作时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 120,
        }, {
            title: '操作人',
            dataIndex: 'operateUserName',
            key: 'operateUserName',
            width: 120,
            render: (text, record) => {
                const { operateUserName, operateUserCode } = record;
                return (operateUserName && operateUserCode) ? `${operateUserName}[${operateUserCode}]` : ''
            }
        }, {
            title: '操作内容',
            dataIndex: 'operateTypeShow',
            key: 'operateTypeShow',
            width: 100,
        }, {
            title: '操作结果',
            dataIndex: 'operateResult',
            key: 'operateResult',
            width: 100,
        }, {
            title: '退回/不承接/拒绝/打回原因',
            dataIndex: 'remark',
            key: 'remark',
            width: 120,
        }, {
            title: '附件',
            dataIndex: 'attachments',
            key: 'attachments',
            width: 120,
            render: (text, record) => {
                const { fileList } = record;
                return (fileList || []).map(el => <a onClick={() => this.downLoadFile(el.fileMateId)}>{el.name}<br /></a>)
            }
        }, {
            title: '评估版本号',
            dataIndex: 'versionNum',
            key: 'versionNum',
            width: 100,
        }] : [{
            title: '操作时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 120,
        }, {
            title: '操作人',
            dataIndex: 'operateUserName',
            key: 'operateUserName',
            width: 120,
            render: (text, record) => {
                const { operateUserName, operateUserCode } = record;
                return (operateUserName && operateUserCode) ? `${operateUserName}[${operateUserCode}]` : ''
            }
        }, {
            title: '操作内容',
            dataIndex: 'operateTypeShow',
            key: 'operateTypeShow',
            width: 100,
        }, {
            title: '操作结果',
            dataIndex: 'operateResult',
            key: 'operateResult',
            width: 100,
        }, {
            title: '查看详情',
            dataIndex: 'details',
            key: 'details',
            width: 100,
            render: (text, record) => {
                const { operateType } = record;
                return (operateType == 'RE_REQUEST_CLINICAL' || operateType == 'SUGGESTION_BASE_PRICE' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && <a onClick={() => this.FloorPriceDetailRef.show(record, talAuth)}>查看建议底价详情</a>
            }
        }, {
            title: '建议报价情况说明/备注说明/不通过原因说明',
            dataIndex: 'remark',
            key: 'remark',
            width: 120,
        }, {
            title: '附件',
            dataIndex: 'attachments',
            key: 'attachments',
            width: 120,
            render: (text, record) => {
                const { fileList, ossFileList, operateType } = record;

                return (operateType == 'SUGGESTION_BASE_PRICE' || operateType == 'RE_REQUEST_CLINICAL' || operateType == 'APPROVAL_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') ? 
                (ossFileList || []).map(el => <a onClick={() => this.downLoadOssFile(el.id)}>{el.fileName}<br /></a>) 
                : 
                (fileList || []).map(el => <a onClick={() => this.downLoadFile(el.fileMateId)}>{el.name}<br /></a>)
            }
        }, {
            title: '报价版本号',
            dataIndex: 'clinicalVersionNum',
            key: 'clinicalVersionNum',
            width: 100,
        }, {
            title: 'GP%测算日志',
            dataIndex: '',
            key: '',
            width: 100,
            render: (text, record) => {
                const { operateType } = record;
                return (operateType == 'SUGGESTION_BASE_PRICE') && (isGpFinSet || isLineCharge || isSeniorUserBo || isLineDeptBO || isFIN) && <a onClick={() => this.GPCalculateLogModalRef.show(record)}>查看详情</a>
            }
        }];
        return columns
    } 

    downLoadFile = (fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    downLoadOssFile = (id) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id }, null, url);
    }

    handleTabClick = (key) => {
        this.setState({
            isQuotation: key,
        },() => {
            this.loadData();
        })
    }

    render() {
        const { visible, loading, data, isQuotation, tabs } = this.state;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1100px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div>
                        <Tabs type="card" activeKey={isQuotation} onChange={this.handleTabClick}>
                            {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                        </Tabs>
                        <TableC
                            rowKey={'evaluateRecordOperateLogId'}
                            data={data}
                            loading={loading}
                            scroll={{ x: 300, y: 400 }}
                            columns={this.getColumns()}
                        />
                        <FloorPriceDetail ref={el => this.FloorPriceDetailRef = el} />
                        <GPCalculateLogModal ref={el => this.GPCalculateLogModalRef = el} />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default OperationLog;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/OperationLog.js